<aside class="sidebar">
  <div class="icon-bar">
    <div class="rail-corner" aria-hidden="true">
      <div class="rail-corner-shape">
        <svg viewBox="0 0 16 80" fill="none">
          <path d="M0 0L16 80H0V0Z" fill="#033A68"/>
        </svg>
      </div>
    </div>

    @if (!isViewPage) {
      <div class="icon-buttons">
        <button class="icon-btn define-btn" [class.active-route]="isDefinePage" routerLink="/define" routerLinkActive="active">
          @if (isDefinePage) {
            <div class="active-btn-shell">
              <div class="active-btn-surface">
                <div class="define-icon define-icon-active">
                  <svg viewBox="0 0 30 30" fill="none" aria-hidden="true">
                    <circle cx="15" cy="15" r="6.25" fill="currentColor"/>
                    <circle cx="15" cy="15" r="9.25" stroke="currentColor" stroke-width="1.5"/>
                    <circle cx="15" cy="15" r="14.25" stroke="currentColor" stroke-width="1.5"/>
                  </svg>
                </div>
                <span class="sr-only">Define</span>
              </div>
            </div>
          } @else {
            <div class="inactive-btn-shell">
              <div class="inactive-btn-content inactive-btn-content-define">
                <div class="define-icon define-icon-inactive">
                  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <circle cx="12" cy="12" r="5" fill="currentColor"/>
                    <circle cx="12" cy="12" r="7.25" stroke="currentColor" stroke-width="1.5"/>
                    <circle cx="12" cy="12" r="11.25" stroke="currentColor" stroke-width="1.5"/>
                  </svg>
                </div>
                <span class="icon-label">Define</span>
              </div>
            </div>
          }
        </button>

        <button class="icon-btn spaces-btn" [class.active-route]="isSpacesPage" routerLink="/spaces" routerLinkActive="active">
          @if (isSpacesPage) {
            <div class="active-btn-shell">
              <div class="active-btn-surface">
                <div class="spaces-icon spaces-icon-active">
                  <svg viewBox="0 0 30 27.5" fill="none" aria-hidden="true">
                    <path d="M27.5 0C28.8807 0 30 1.11929 30 2.5V5C30 6.38071 28.8807 7.5 27.5 7.5H2.5C1.11929 7.5 0 6.38071 0 5V2.5C0 1.11929 1.11929 0 2.5 0H27.5ZM5 1.25C3.61929 1.25 2.5 2.36929 2.5 3.75C2.5 5.13071 3.61929 6.25 5 6.25C6.38071 6.25 7.5 5.13071 7.5 3.75C7.5 2.36929 6.38071 1.25 5 1.25Z" fill="currentColor"/>
                    <path d="M27.5 10C28.8807 10 30 11.1193 30 12.5V15C30 16.3807 28.8807 17.5 27.5 17.5H2.5C1.11929 17.5 0 16.3807 0 15V12.5C0 11.1193 1.11929 10 2.5 10H27.5ZM5 11.25C3.61929 11.25 2.5 12.3693 2.5 13.75C2.5 15.1307 3.61929 16.25 5 16.25C6.38071 16.25 7.5 15.1307 7.5 13.75C7.5 12.3693 6.38071 11.25 5 11.25Z" fill="currentColor"/>
                    <path d="M27.5 20C28.8807 20 30 21.1193 30 22.5V25C30 26.3807 28.8807 27.5 27.5 27.5H2.5C1.11929 27.5 0 26.3807 0 25V22.5C0 21.1193 1.11929 20 2.5 20H27.5ZM5 21.25C3.61929 21.25 2.5 22.3693 2.5 23.75C2.5 25.1307 3.61929 26.25 5 26.25C6.38071 26.25 7.5 25.1307 7.5 23.75C7.5 22.3693 6.38071 21.25 5 21.25Z" fill="currentColor"/>
                  </svg>
                </div>
                <span class="sr-only">Spaces</span>
              </div>
            </div>
          } @else {
            <div class="inactive-btn-shell">
              <div class="inactive-btn-content">
                <div class="spaces-icon spaces-icon-inactive">
                  <svg viewBox="0 0 24 22" fill="none" aria-hidden="true">
                    <path d="M22 0C23.1046 0 24 0.895431 24 2V4C24 5.10457 23.1046 6 22 6H2C0.895431 6 0 5.10457 0 4V2C0 0.895431 0.895431 0 2 0H22ZM4 1C2.89543 1 2 1.89543 2 3C2 4.10457 2.89543 5 4 5C5.10457 5 6 4.10457 6 3C6 1.89543 5.10457 1 4 1Z" fill="currentColor"/>
                    <path d="M22 8C23.1046 8 24 8.89543 24 10V12C24 13.1046 23.1046 14 22 14H2C0.895431 14 0 13.1046 0 12V10C0 8.89543 0.895431 8 2 8H22ZM4 9C2.89543 9 2 9.89543 2 11C2 12.1046 2.89543 13 4 13C5.10457 13 6 12.1046 6 11C6 9.89543 5.10457 9 4 9Z" fill="currentColor"/>
                    <path d="M22 16C23.1046 16 24 16.8954 24 18V20C24 21.1046 23.1046 22 22 22H2C0.895431 22 0 21.1046 0 20V18C0 16.8954 0.895431 16 2 16H22ZM4 17C2.89543 17 2 17.8954 2 19C2 20.1046 2.89543 21 4 21C5.10457 21 6 20.1046 6 19C6 17.8954 5.10457 17 4 17Z" fill="currentColor"/>
                  </svg>
                </div>
                <span class="icon-label">Spaces</span>
              </div>
            </div>
          }
        </button>
      </div>
    }

    <div class="allplan-logo-bottom">
      <svg viewBox="0 0 20.25 24" fill="none">
        <path d="M12.1091 0H8.0937L0 24H3.41699L9.82582 3.44H9.8888L16.2346 24H20.25L12.1091 0Z" fill="white"/>
      </svg>
    </div>
  </div>

  <nav class="nav-panel">
    @if (isViewPage) {
      <app-view-sidebar></app-view-sidebar>
    } @else if (isSpacesPage) {
      <app-spaces-sidebar></app-spaces-sidebar>
    } @else {
      <app-define-sidebar></app-define-sidebar>
    }
  </nav>
</aside>
